var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Customize prompt visibility",
        label: "Save",
        description: "Select the prompts that are visible during the session.",
        submitLoading: _vm.submitLoading
      },
      on: {
        "backdrop-close": _vm.onCancel,
        "backdrop-action": _vm.onSavePrompts
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "grid grid-cols-2 gap-6 px-8 py-4 overflow-y-auto w-200",
          style: { maxHeight: "calc(100vh - 16rem)" }
        },
        [
          _c(
            "div",
            _vm._l(_vm.defaultPrompts, function(prompt) {
              return _c(
                "div",
                {
                  key: prompt.key,
                  class: [
                    prompt.name === _vm.successMetric
                      ? "cursor-not-allowed"
                      : "cursor-pointer"
                  ]
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center h-10 gap-2 truncate",
                      class: {
                        "pointer-events-none": prompt.name === _vm.successMetric
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.toggleEnabled(prompt)
                        }
                      }
                    },
                    [
                      _c("BlInputToggle", {
                        staticClass: "flex-shrink-0",
                        class: { "opacity-50": prompt.enabled },
                        attrs: {
                          disabled: prompt.name === _vm.successMetric,
                          checked: prompt.enabled
                        },
                        on: {
                          changed: function($event) {
                            return _vm.toggleEnabled(prompt)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex truncate" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "truncate",
                            attrs: { text: prompt.name, title: prompt.name }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      prompt.shape && prompt.color
                        ? _c("BlIcon", {
                            staticClass: "w-5",
                            attrs: {
                              icon: "prompt-" + prompt.shape,
                              color: prompt.color
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      prompt.name === _vm.successMetric
                        ? _c("BlTextBody2", {
                            staticClass: "text-xs italic",
                            attrs: { text: "as success metric" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flex items-center justify-center p-4 border rounded bg-grey-100 border-grey-200",
              style:
                _vm.defaultPrompts.length > 8
                  ? { height: _vm.defaultPrompts.length * 2.5 + "rem" }
                  : { height: "20rem" }
            },
            [
              _c("PromptPreview", {
                style: { transform: "scale(0.5 , 0.5)" },
                attrs: {
                  prompts: _vm.defaultPrompts.filter(function(i) {
                    return i.enabled
                  })
                }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-523a110c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523a110c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/modal/CustomizePromptModal.vue
// module id = null
// module chunks = 